import React from 'react';
import { Stack, Typography } from 'components/base';
import EmailIcon from 'assets/img/email.png';

export const ResponseReceived: React.FC = () => (
  <Stack alignItems="center" justifyContent="center">
    <img src={EmailIcon} alt="Email" width="120px" />
    <Typography variant="h6" color="text.primary" mt={1}>
      Thank you!!
    </Typography>
    <Typography variant="body2" color="text.secondary">
      Your submission has been received.
    </Typography>
    <Typography variant="body2" color="text.secondary">
      A copy of this submission is sent to the provided email.
    </Typography>
    <Typography variant="caption" color="text.secondary">
      You can close this window.
    </Typography>
  </Stack>
);
